import React from 'react';

function BillPerPeriodCell(billPerPeriod: any) {

  if (billPerPeriod.text === "") {
    return (
      <div>
        {
          (Number(billPerPeriod.data.bill) === -1) ? <></> :
            <span>{Number(billPerPeriod.data.bill).toFixed(2)} ฿</span>
        }
      </div>
    )
  } else {
    return (
      <span>{Number(billPerPeriod.text).toFixed(2)} ฿</span>
    )
  }

}
export default BillPerPeriodCell;